import {Fragment} from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

interface IProps {
    message: string;
}

const SMS_LOGIN_ERROR_BOLD_PARTS = ["Popraw numer, aby kontynuować,", "adres e-mail, by założyć nowe konto."];

export const SmsLoginAccountMismatchMessage = (props: IProps) => {
    const {message} = props;
    let parts = [message];

    for (const boldPart of SMS_LOGIN_ERROR_BOLD_PARTS) {
        parts = parts.flatMap((part) =>
            part === boldPart ? [part] : part.split(boldPart).flatMap((messagePart, index) => (index === 0 ? [messagePart] : [boldPart, messagePart]))
        );
    }

    return (
        <Text as="div" variant="info_txt_1" className={smsLoginErrorStyle}>
            {parts.map((part, index) => {
                if (!part) {
                    return null;
                }

                if (SMS_LOGIN_ERROR_BOLD_PARTS.includes(part)) {
                    return <strong key={`${part}-${index}`}>{part}</strong>;
                }

                return <Fragment key={`${part}-${index}`}>{part}</Fragment>;
            })}
        </Text>
    );
};

const smsLoginErrorStyle = css({
    mt: 1,
    p: 1,
    borderRadius: 1,
    color: "var(--colors-white)",
    backgroundColor: "var(--colors-gray-800)"
});
import {Fragment} from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

interface IProps {
    message: string;
}

const SMS_LOGIN_ERROR_BOLD_PARTS = ["Popraw numer, aby kontynuować,", "adres e-mail, by założyć nowe konto."];

export const SmsLoginAccountMismatchMessage = (props: IProps) => {
    const {message} = props;
    let parts = [message];

    for (const boldPart of SMS_LOGIN_ERROR_BOLD_PARTS) {
        parts = parts.flatMap((part) =>
            part === boldPart ? [part] : part.split(boldPart).flatMap((messagePart, index) => (index === 0 ? [messagePart] : [boldPart, messagePart]))
        );
    }

    return (
        <Text as="div" variant="info_txt_1" className={smsLoginErrorStyle}>
            {parts.map((part, index) => {
                if (!part) {
                    return null;
                }

                if (SMS_LOGIN_ERROR_BOLD_PARTS.includes(part)) {
                    return <strong key={`${part}-${index}`}>{part}</strong>;
                }

                return <Fragment key={`${part}-${index}`}>{part}</Fragment>;
            })}
        </Text>
    );
};

const smsLoginErrorStyle = css({
    mt: 1,
    p: 1,
    borderRadius: 1,
    color: "var(--colors-white)",
    backgroundColor: "var(--colors-gray-800)"
});
